import socketio from "socket.io-client";
import { IWMURL } from "./urlConfig";

export const socket = socketio(IWMURL, {
  extraHeaders: {
    authorization: localStorage.getItem("IWM_CCXT"),
  },
});
